<template>
  <div>
    <b-modal
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
      scrollable
      :title="
        (isEditWorkFlow
          ? 'Update '
          : isDuplicateWorkFlow
          ? 'Duplicate '
          : 'Add New ') + ' Employee Onboarding'
      "
      size="xl"
      :lazy="true"
      v-model="showAddModal"
    >
      <div>
        <div v-if="!submiting && !responseSuccess">
          <b-tabs
            small
            card
            fill
          >
            <b-tab title="Setup">
              <b-row>
                <b-col cols="6">
                  <b-form-group description="Please enter a title">
                    <label class="text-left">
                      Title:
                      <span class="required-span">*</span>
                    </label>
                    <b-form-input
                      size="sm"
                      type="text"
                      v-model.lazy="$v.form.title.$model"
                      :state="
                        $v.form.title.$dirty ? !$v.form.title.$error : null
                      "
                      @input="setTitleValue"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group description="Please enter a version">
                    <label class="text-left">
                      Version:
                      <span class="required-span">*</span>
                    </label>
                    <b-form-input
                      size="sm"
                      type="text"
                      v-model="$v.form.version.$model"
                      :state="
                        $v.form.version.$dirty ? !$v.form.version.$error : null
                      "
                    ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row class="mt-4">
                <b-col
                  cols="6"
                  v-if="form.title"
                >
                  <b-form-group>
                    <b-form-checkbox
                      inline
                      v-model="selectedLanguage"
                      v-for="(language, index) in languagesOptions"
                      :key="index"
                      :value="language"
                      :disabled="language.text == 'English' ? true : false"
                    >{{ language.text }}</b-form-checkbox>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab
              title="Configration"
              v-if="form.title"
            >
              <b-tabs
                small
                card
                fill
              >
                <b-tab title="Proccess">
                  <b-card title="Create Different Workflow Proccesses">
                    <b-button
                      class="float-right"
                      size="sm"
                      variant="outline-info"
                      @click="addRowInTable"
                    >
                      <font-awesome-icon icon="plus" />
                    </b-button>
                    <b-table-simple class="table my-2">
                      <b-thead>
                        <b-tr>
                          <b-th scope="col">
                            Title
                            <span class="required-span">*</span>
                          </b-th>
                          <b-th scope="col">
                            Start From
                            <span class="required-span">*</span>
                          </b-th>
                          <b-th scope="col">
                            To Date
                            <span class="required-span">*</span>
                          </b-th>
                          <b-th scope="col">Action</b-th>
                        </b-tr>
                      </b-thead>

                      <b-tbody>
                        <b-tr
                          v-for="(cloenFields,
                          cloenFieldsIndex) in configrationSettings"
                          :key="cloenFieldsIndex"
                        >
                          <b-td>
                            <b-form-group :invalid-feedback="invalidTitleValue">
                              <b-form-input
                                @change="
                                  setTitleIndex($event, cloenFieldsIndex)"
                                size="sm"
                                :state="invalidTitleValue ? false : null"
                                v-model="
                                  configrationSettings[cloenFieldsIndex].title"
                              ></b-form-input>
                            </b-form-group>
                          </b-td>
                          <b-td>
                            <b-form-group>
                              <b-input-group>
                                <Datepicker
                                  wrapper-class="form-control-small-date-picker"
                                  input-class="workflow-setting-custom-date-picker"
                                  calendar-class="workflow-setting-date-calender"
                                  class="form-control"
                                  :format="formatDate"
                                  :class="invalidStartDateValue ? 'border border-danger rounded' : null"
                                  v-model="configrationSettings[cloenFieldsIndex].startDate"
                                  @input="setStartDateIndex($event, cloenFieldsIndex)"
                                ></Datepicker>
                                <b-input-group-append>
                                  <span class="input-group-text">
                                    <i class="fa fa-calendar"></i>
                                  </span>
                                </b-input-group-append>
                                <p
                                  v-if="invalidStartDateValue"
                                  class="text-feedback"
                                >
                                  {{ invalidStartDateValue }}
                                </p>
                              </b-input-group>
                            </b-form-group>
                          </b-td>
                          <b-td>
                            <b-form-group>
                              <b-input-group>
                                <Datepicker
                                  wrapper-class="form-control-small-date-picker"
                                  input-class="workflow-setting-custom-date-picker"
                                  calendar-class="workflow-setting-date-calender"
                                  class="form-control"
                                  :format="formatDate"
                                  :class="invalidEndDateValue ? 'border border-danger rounded' : null"
                                  v-model="configrationSettings[cloenFieldsIndex].endDateValue"
                                  @input="setEndDateIndex($event, cloenFieldsIndex)"
                                  @closed="setSettingsLanuages(cloenFieldsIndex)"
                                ></Datepicker>
                                <b-input-group-append>
                                  <span class="input-group-text">
                                    <i class="fa fa-calendar"></i>
                                  </span>
                                </b-input-group-append>
                                <p
                                  v-if="invalidEndDateValue"
                                  class="text-feedback"
                                >
                                  {{ invalidEndDateValue }}
                                </p>
                              </b-input-group>
                            </b-form-group>
                          </b-td>
                          <b-td style="padding-top: 0px">
                            <b-button
                              variant="outline-danger"
                              v-if="cloenFieldsIndex > 0"
                              size="sm"
                              @click="onDeleteAmountRow(cloenFieldsIndex)"
                            >
                              <i class="fa fa-trash"></i>
                            </b-button>
                          </b-td>
                        </b-tr>
                      </b-tbody>
                    </b-table-simple>
                  </b-card>
                </b-tab>
                <b-tab
                  :title="configurTab.title"
                  v-for="(configurTab, configurTabIndex) in configrationSettings"
                  :key="configurTabIndex"
                  v-if="configurTab.endDateValue != null"
                  @click="setEmailLanguages(configurTabIndex)"
                >
                  <b-card>
                    <b-tabs>
                      <b-tab title="Configration">
                        <b-form-group label="Email Tags:">
                          <multiselect
                            v-model.lazy="configrationSettings[configrationSettingsIndex].configration.emailTags"
                            label="text"
                            track-by="value"
                            :options="emailTagsOptions"
                            :multiple="true"
                            :taggable="true"
                          ></multiselect>
                        </b-form-group>
                        <b-form-group
                          class="mt-3"
                          label="Platform Setting:"
                        >
                          <multiselect
                            v-model.lazy="configrationSettings[configrationSettingsIndex].configration.platformSettings"
                            label="platform_variable_name"
                            track-by="platform_variable_value"
                            :options="platformSettingOptions"
                            :multiple="true"
                            :taggable="true"
                          ></multiselect>
                        </b-form-group>
                      </b-tab>
                      <b-tab title="Policy">
                        <b-tabs>
                          <b-tab title="Forms">
                            <b-form-group
                              label="Select Policy Onboarding Forms"
                              class="mt-4"
                            >
                              <b-form-checkbox
                                inline
                                v-model="configrationSettings[configrationSettingsIndex].policyForms.forms"
                                v-for="(forms, index) in policyFormsOptions"
                                :key="index"
                                :value="forms"
                              >{{ forms.text }}</b-form-checkbox>
                            </b-form-group>
                          </b-tab>
                          <b-tab title="Email">
                            <b-card>
                              <b-tabs
                                small
                                nav-class="employee-languages-tabs-layout"
                              >
                                <b-tab
                                  v-for="(emailLanguage, lanuageIndex) in selectedLanguage"
                                  :key="lanuageIndex"
                                  :title="emailLanguage.text"
                                >
                                  <b-tabs
                                    justified
                                    vertical
                                    pills
                                    small
                                    fill
                                  >
                                    <b-tab title="Tasks Email">
                                      <label class="mt-3 mb-0">Tasks Email</label>
                                      <div class="my-2">
                                        <b-row>
                                          <b-col cols="6">
                                            <b-card>
                                              <b-card-body
                                                class="p-0"
                                                style="height: 70px;overflow-y: auto;"
                                              >
                                                <span
                                                  v-for="(tags, tagsIndex) in configrationSettings[configrationSettingsIndex].configration.emailTags"
                                                  :key="tagsIndex"
                                                  class="mr-2"
                                                >
                                                  <b-badge
                                                    variant="success"
                                                    style="cursor: pointer;"
                                                  >
                                                    <p @click="setTagValue('[['+tags.text+']]', configrationSettingsIndex, emailLanguage.value, 'policyForms', 'tasksEmail')">{{ tags.text }}</p>
                                                  </b-badge>
                                                </span>
                                              </b-card-body>
                                            </b-card>
                                          </b-col>
                                          <b-col cols="6">
                                            <b-card>
                                              <b-card-body
                                                class="p-0"
                                                style="height: 70px;overflow-y: auto;"
                                              >
                                                <span
                                                  v-for="(platform, platformIndex) in configrationSettings[configrationSettingsIndex].configration.platformSettings"
                                                  :key="platformIndex"
                                                  class="mr-2"
                                                >
                                                  <b-badge
                                                    variant="success"
                                                    style="cursor: pointer;"
                                                  >
                                                    <p @click="setTagValue('{{'+platform.platform_variable_key+'}}', configrationSettingsIndex, emailLanguage.value, 'policyForms', 'tasksEmail')">{{ platform.platform_variable_name }}</p>
                                                  </b-badge>
                                                </span>
                                              </b-card-body>
                                            </b-card>
                                          </b-col>
                                        </b-row>
                                      </div>
                                      <b-form-group
                                        class="my-3"
                                        label="Email Subject"
                                      >
                                        <b-form-input
                                          v-model="configrationSettings[configrationSettingsIndex].policyForms.emails[emailLanguage.value].tasksEmail.subject"
                                          size="sm"
                                        ></b-form-input>
                                      </b-form-group>
                                      <b-spinner
                                        v-if="policyFormsTasksEmail"
                                        label="Spinning"
                                      ></b-spinner>
                                      <b-form-group
                                        v-else
                                        label="Email Body"
                                      >
                                        <wysiwyg v-model="configrationSettings[configrationSettingsIndex].policyForms.emails[emailLanguage.value].tasksEmail.message" />
                                      </b-form-group>
                                    </b-tab>
                                    <b-tab title="Tasks Reminder Email">
                                      <label class="mt-3 mb-0">Tasks Reminder Email</label>
                                      <div class="my-2">
                                        <b-row>
                                          <b-col cols="6">
                                            <b-card>
                                              <b-card-body
                                                class="p-0"
                                                style="height: 70px;overflow-y: auto;"
                                              >
                                                <span
                                                  v-for="(tags, tagsIndex) in configrationSettings[configrationSettingsIndex].configration.emailTags"
                                                  :key="tagsIndex"
                                                  class="mr-2"
                                                >
                                                  <b-badge variant="success">
                                                    <p @click="setTagValue('[['+tags.text+']]', configrationSettingsIndex, emailLanguage.value, 'policyForms', 'taskReminderEmail')">{{ tags.text }}</p>
                                                  </b-badge>
                                                </span>
                                              </b-card-body>
                                            </b-card>
                                          </b-col>
                                          <b-col cols="6">
                                            <b-card>
                                              <b-card-body
                                                class="p-0"
                                                style="height: 70px;overflow-y: auto;"
                                              >
                                                <span
                                                  v-for="(platform, platformIndex) in configrationSettings[configrationSettingsIndex].configration.platformSettings"
                                                  :key="platformIndex"
                                                  class="mr-2"
                                                >
                                                  <b-badge
                                                    variant="success"
                                                    style="cursor: pointer;"
                                                  >
                                                    <p @click="setTagValue('{{'+platform.platform_variable_key+'}}', configrationSettingsIndex, emailLanguage.value, 'policyForms', 'taskReminderEmail')">{{ platform.platform_variable_name }}</p>
                                                  </b-badge>
                                                </span>
                                              </b-card-body>
                                            </b-card>
                                          </b-col>
                                        </b-row>
                                      </div>
                                      <b-form-group
                                        class="my-3"
                                        label="Email Subject"
                                      >
                                        <b-form-input
                                          v-model="configrationSettings[configrationSettingsIndex].policyForms.emails[emailLanguage.value].taskReminderEmail.subject"
                                          size="sm"
                                        ></b-form-input>
                                      </b-form-group>
                                      <b-spinner
                                        v-if="policyFormsTasksReminderEmail"
                                        label="Spinning"
                                      ></b-spinner>
                                      <b-form-group
                                        v-else
                                        label="Email Body"
                                      >
                                        <wysiwyg v-model="configrationSettings[configrationSettingsIndex].policyForms.emails[emailLanguage.value].taskReminderEmail.message" />
                                      </b-form-group>
                                    </b-tab>
                                    <b-tab title="Tasks Completion Email">
                                      <label class="mt-3 mb-0">Tasks Completion Email</label>
                                      <div class="my-2">
                                        <b-row>
                                          <b-col cols="6">
                                            <b-card>
                                              <b-card-body
                                                class="p-0"
                                                style="height: 70px;overflow-y: auto;"
                                              >
                                                <span
                                                  v-for="(tags, tagsIndex) in configrationSettings[configrationSettingsIndex].configration.emailTags"
                                                  :key="tagsIndex"
                                                  class="mr-2"
                                                >
                                                  <b-badge variant="success">
                                                    <p @click="setTagValue('[['+tags.text+']]', configrationSettingsIndex, emailLanguage.value, 'policyForms', 'taskCompletionEmail')">{{ tags.text }}</p>
                                                  </b-badge>
                                                </span>
                                              </b-card-body>
                                            </b-card>
                                          </b-col>
                                          <b-col cols="6">
                                            <b-card>
                                              <b-card-body
                                                class="p-0"
                                                style="height: 70px;overflow-y: auto;"
                                              >
                                                <span
                                                  v-for="(platform, platformIndex) in configrationSettings[configrationSettingsIndex].configration.platformSettings"
                                                  :key="platformIndex"
                                                  class="mr-2"
                                                >
                                                  <b-badge
                                                    variant="success"
                                                    style="cursor: pointer;"
                                                  >
                                                    <p @click="setTagValue('{{'+platform.platform_variable_key+'}}', configrationSettingsIndex, emailLanguage.value, 'policyForms', 'taskCompletionEmail')">{{ platform.platform_variable_name }}</p>
                                                  </b-badge>
                                                </span>
                                              </b-card-body>
                                            </b-card>
                                          </b-col>
                                        </b-row>
                                      </div>
                                      <b-form-group
                                        class="my-3"
                                        label="Email Subject"
                                      >
                                        <b-form-input
                                          v-model="configrationSettings[configrationSettingsIndex].policyForms.emails[emailLanguage.value].taskCompletionEmail.subject"
                                          size="sm"
                                        ></b-form-input>
                                      </b-form-group>
                                      <b-spinner
                                        v-if="policyFormsTasksCompletionEmail"
                                        label="Spinning"
                                      ></b-spinner>
                                      <b-form-group
                                        v-else
                                        label="Email Body"
                                      >
                                        <wysiwyg v-model="configrationSettings[configrationSettingsIndex].policyForms.emails[emailLanguage.value].taskCompletionEmail.message" />
                                      </b-form-group>
                                    </b-tab>
                                    <b-tab title="Renew Tasks Email">
                                      <label class="mt-3 mb-0">Renew Tasks Email</label>
                                      <div class="my-2">
                                        <b-row>
                                          <b-col cols="6">
                                            <b-card>
                                              <b-card-body
                                                class="p-0"
                                                style="height: 70px;overflow-y: auto;"
                                              >
                                                <span
                                                  v-for="(tags, tagsIndex) in configrationSettings[configrationSettingsIndex].configration.emailTags"
                                                  :key="tagsIndex"
                                                  class="mr-2"
                                                >
                                                  <b-badge variant="success">
                                                    <p @click="setTagValue('[['+tags.text+']]', configrationSettingsIndex, emailLanguage.value, 'policyForms', 'renewTasksEmail')">{{ tags.text }}</p>
                                                  </b-badge>
                                                </span>
                                              </b-card-body>
                                            </b-card>
                                          </b-col>
                                          <b-col cols="6">
                                            <b-card>
                                              <b-card-body
                                                class="p-0"
                                                style="height: 70px;overflow-y: auto;"
                                              >
                                                <span
                                                  v-for="(platform, platformIndex) in configrationSettings[configrationSettingsIndex].configration.platformSettings"
                                                  :key="platformIndex"
                                                  class="mr-2"
                                                >
                                                  <b-badge
                                                    variant="success"
                                                    style="cursor: pointer;"
                                                  >
                                                    <p @click="setTagValue('{{'+platform.platform_variable_key+'}}', configrationSettingsIndex, emailLanguage.value, 'policyForms', 'renewTasksEmail')">{{ platform.platform_variable_name }}</p>
                                                  </b-badge>
                                                </span>
                                              </b-card-body>
                                            </b-card>
                                          </b-col>
                                        </b-row>
                                      </div>
                                      <b-form-group
                                        class="my-3"
                                        label="Email Subject"
                                      >
                                        <b-form-input
                                          v-model="configrationSettings[configrationSettingsIndex].policyForms.emails[emailLanguage.value].renewTasksEmail.subject"
                                          size="sm"
                                        ></b-form-input>
                                      </b-form-group>
                                      <b-spinner
                                        v-if="policyFormsRenewTasksEmail"
                                        label="Spinning"
                                      ></b-spinner>
                                      <b-form-group
                                        v-else
                                        label="Email Body"
                                      >
                                        <wysiwyg v-model="configrationSettings[configrationSettingsIndex].policyForms.emails[emailLanguage.value].renewTasksEmail.message" />
                                      </b-form-group>
                                    </b-tab>
                                  </b-tabs>
                                </b-tab>
                              </b-tabs>
                            </b-card>
                          </b-tab>
                        </b-tabs>
                      </b-tab>
                      <b-tab title="Training">
                        <b-tabs>
                          <b-tab title="Forms">
                            <b-form-group
                              label="Select Training Forms"
                              class="mt-4"
                            >
                              <b-form-checkbox
                                inline
                                v-model="configrationSettings[configrationSettingsIndex].trainingForms.forms"
                                v-for="(forms, index) in trainingFormsOptions"
                                :key="index"
                                :value="forms"
                              >{{ forms.text }}</b-form-checkbox>
                            </b-form-group>
                          </b-tab>
                          <b-tab title="Email">
                            <b-card>
                              <b-tabs
                                small
                                nav-class="employee-languages-tabs-layout"
                              >
                                <b-tab
                                  v-for="(emailLanguage, lanuageIndex) in selectedLanguage"
                                  :key="lanuageIndex"
                                  :title="emailLanguage.text"
                                >
                                  <b-tabs
                                    justified
                                    vertical
                                    pills
                                    small
                                    fill
                                  >
                                    <b-tab title="Tasks Email">
                                      <label class="mt-3 mb-0">Tasks Email</label>
                                      <div class="my-2">
                                        <b-row>
                                          <b-col cols="6">
                                            <b-card>
                                              <b-card-body
                                                class="p-0"
                                                style="height: 70px;overflow-y: auto;"
                                              >
                                                <span
                                                  v-for="(tags, tagsIndex) in configrationSettings[configrationSettingsIndex].configration.emailTags"
                                                  :key="tagsIndex"
                                                  class="mr-2"
                                                >
                                                  <b-badge variant="success">
                                                    <p @click="setTagValue('[['+tags.text+']]', configrationSettingsIndex, emailLanguage.value, 'trainingForms', 'tasksEmail')">{{ tags.text }}</p>
                                                  </b-badge>
                                                </span>
                                              </b-card-body>
                                            </b-card>
                                          </b-col>
                                          <b-col cols="6">
                                            <b-card>
                                              <b-card-body
                                                class="p-0"
                                                style="height: 70px;overflow-y: auto;"
                                              >
                                                <span
                                                  v-for="(platform, platformIndex) in configrationSettings[configrationSettingsIndex].configration.platformSettings"
                                                  :key="platformIndex"
                                                  class="mr-2"
                                                >
                                                  <b-badge
                                                    variant="success"
                                                    style="cursor: pointer;"
                                                  >
                                                    <p @click="setTagValue('{{'+platform.platform_variable_key+'}}', configrationSettingsIndex, emailLanguage.value, 'trainingForms', 'tasksEmail')">{{ platform.platform_variable_name }}</p>
                                                  </b-badge>
                                                </span>
                                              </b-card-body>
                                            </b-card>
                                          </b-col>
                                        </b-row>
                                      </div>
                                      <b-form-group
                                        class="my-3"
                                        label="Email Subject"
                                      >
                                        <b-form-input
                                          v-model="configrationSettings[configrationSettingsIndex].trainingForms.emails[emailLanguage.value].tasksEmail.subject"
                                          size="sm"
                                        ></b-form-input>
                                      </b-form-group>
                                      <b-spinner
                                        v-if="trainingFormsTasksEmail"
                                        label="Spinning"
                                      ></b-spinner>
                                      <b-form-group
                                        v-else
                                        label="Email Body"
                                      >
                                        <wysiwyg v-model="configrationSettings[configrationSettingsIndex].trainingForms.emails[emailLanguage.value].tasksEmail.message" />
                                      </b-form-group>
                                    </b-tab>
                                    <b-tab title="Tasks Reminder Email">
                                      <label class="mt-3 mb-0">Tasks Reminder Email</label>
                                      <div class="my-2">
                                        <b-row>
                                          <b-col cols="6">
                                            <b-card>
                                              <b-card-body
                                                class="p-0"
                                                style="height: 70px;overflow-y: auto;"
                                              >
                                                <span
                                                  v-for="(tags, tagsIndex) in configrationSettings[configrationSettingsIndex].configration.emailTags"
                                                  :key="tagsIndex"
                                                  class="mr-2"
                                                >
                                                  <b-badge variant="success">
                                                    <p @click="setTagValue('[['+tags.text+']]', configrationSettingsIndex, emailLanguage.value, 'trainingForms', 'taskReminderEmail')">{{ tags.text }}</p>
                                                  </b-badge>
                                                </span>
                                              </b-card-body>
                                            </b-card>
                                          </b-col>
                                          <b-col cols="6">
                                            <b-card>
                                              <b-card-body
                                                class="p-0"
                                                style="height: 70px;overflow-y: auto;"
                                              >
                                                <span
                                                  v-for="(platform, platformIndex) in configrationSettings[configrationSettingsIndex].configration.platformSettings"
                                                  :key="platformIndex"
                                                  class="mr-2"
                                                >
                                                  <b-badge
                                                    variant="success"
                                                    style="cursor: pointer;"
                                                  >
                                                    <p @click="setTagValue('{{'+platform.platform_variable_key+'}}', configrationSettingsIndex, emailLanguage.value, 'trainingForms', 'taskReminderEmail')">{{ platform.platform_variable_name }}</p>
                                                  </b-badge>
                                                </span>
                                              </b-card-body>
                                            </b-card>
                                          </b-col>
                                        </b-row>
                                      </div>
                                      <b-form-group
                                        class="my-3"
                                        label="Email Subject"
                                      >
                                        <b-form-input
                                          v-model="configrationSettings[configrationSettingsIndex].trainingForms.emails[emailLanguage.value].taskReminderEmail.subject"
                                          size="sm"
                                        ></b-form-input>
                                      </b-form-group>
                                      <b-spinner
                                        v-if="trainingFormsTasksReminderEmail"
                                        label="Spinning"
                                      ></b-spinner>
                                      <b-form-group
                                        v-else
                                        label="Email Body"
                                      >
                                        <wysiwyg v-model="configrationSettings[configrationSettingsIndex].trainingForms.emails[emailLanguage.value].taskReminderEmail.message" />
                                      </b-form-group>
                                    </b-tab>
                                    <b-tab title="Tasks Completion Email">
                                      <label class="mt-3 mb-0">Tasks Completion Email</label>
                                      <div class="my-2">
                                        <b-row>
                                          <b-col cols="6">
                                            <b-card>
                                              <b-card-body
                                                class="p-0"
                                                style="height: 70px;overflow-y: auto;"
                                              >
                                                <span
                                                  v-for="(tags, tagsIndex) in configrationSettings[configrationSettingsIndex].configration.emailTags"
                                                  :key="tagsIndex"
                                                  class="mr-2"
                                                >
                                                  <b-badge variant="success">
                                                    <p @click="setTagValue('[['+tags.text+']]', configrationSettingsIndex, emailLanguage.value, 'trainingForms', 'taskCompletionEmail')">{{ tags.text }}</p>
                                                  </b-badge>
                                                </span>
                                              </b-card-body>
                                            </b-card>
                                          </b-col>
                                          <b-col cols="6">
                                            <b-card>
                                              <b-card-body
                                                class="p-0"
                                                style="height: 70px;overflow-y: auto;"
                                              >
                                                <span
                                                  v-for="(platform, platformIndex) in configrationSettings[configrationSettingsIndex].configration.platformSettings"
                                                  :key="platformIndex"
                                                  class="mr-2"
                                                >
                                                  <b-badge
                                                    variant="success"
                                                    style="cursor: pointer;"
                                                  >
                                                    <p @click="setTagValue('{{'+platform.platform_variable_key+'}}', configrationSettingsIndex, emailLanguage.value, 'trainingForms', 'taskCompletionEmail')">{{ platform.platform_variable_name }}</p>
                                                  </b-badge>
                                                </span>
                                              </b-card-body>
                                            </b-card>
                                          </b-col>
                                        </b-row>
                                      </div>
                                      <b-form-group
                                        class="my-3"
                                        label="Email Subject"
                                      >
                                        <b-form-input
                                          v-model="configrationSettings[configrationSettingsIndex].trainingForms.emails[emailLanguage.value].taskCompletionEmail.subject"
                                          size="sm"
                                        ></b-form-input>
                                      </b-form-group>
                                      <b-spinner
                                        v-if="trainingFormsTasksCompletionEmail"
                                        label="Spinning"
                                      ></b-spinner>
                                      <b-form-group
                                        v-else
                                        label="Email Body"
                                      >
                                        <wysiwyg v-model="configrationSettings[configrationSettingsIndex].trainingForms.emails[emailLanguage.value].taskCompletionEmail.message" />
                                      </b-form-group>
                                    </b-tab>
                                    <b-tab title="Renew Tasks Email">
                                      <label class="mt-3 mb-0">Renew Tasks Email</label>
                                      <div class="my-2">
                                        <b-row>
                                          <b-col cols="6">
                                            <b-card>
                                              <b-card-body
                                                class="p-0"
                                                style="height: 70px;overflow-y: auto;"
                                              >
                                                <span
                                                  v-for="(tags, tagsIndex) in configrationSettings[configrationSettingsIndex].configration.emailTags"
                                                  :key="tagsIndex"
                                                  class="mr-2"
                                                >
                                                  <b-badge variant="success">
                                                    <p @click="setTagValue('[['+tags.text+']]', configrationSettingsIndex, emailLanguage.value, 'trainingForms', 'renewTasksEmail')">{{ tags.text }}</p>
                                                  </b-badge>
                                                </span>
                                              </b-card-body>
                                            </b-card>
                                          </b-col>
                                          <b-col cols="6">
                                            <b-card>
                                              <b-card-body
                                                class="p-0"
                                                style="height: 70px;overflow-y: auto;"
                                              >
                                                <span
                                                  v-for="(platform, platformIndex) in configrationSettings[configrationSettingsIndex].configration.platformSettings"
                                                  :key="platformIndex"
                                                  class="mr-2"
                                                >
                                                  <b-badge
                                                    variant="success"
                                                    style="cursor: pointer;"
                                                  >
                                                    <p @click="setTagValue('{{'+platform.platform_variable_key+'}}', configrationSettingsIndex, emailLanguage.value, 'trainingForms', 'renewTasksEmail')">{{ platform.platform_variable_name }}</p>
                                                  </b-badge>
                                                </span>
                                              </b-card-body>
                                            </b-card>
                                          </b-col>
                                        </b-row>
                                      </div>
                                      <b-form-group
                                        class="my-3"
                                        label="Email Subject"
                                      >
                                        <b-form-input
                                          v-model="configrationSettings[configrationSettingsIndex].trainingForms.emails[emailLanguage.value].renewTasksEmail.subject"
                                          size="sm"
                                        ></b-form-input>
                                      </b-form-group>
                                      <b-spinner
                                        v-if="trainingFormsRenewTasksEmail"
                                        label="Spinning"
                                      ></b-spinner>
                                      <b-form-group
                                        v-else
                                        label="Email Body"
                                      >
                                        <wysiwyg v-model="configrationSettings[configrationSettingsIndex].trainingForms.emails[emailLanguage.value].renewTasksEmail.message" />
                                      </b-form-group>
                                    </b-tab>
                                  </b-tabs>
                                </b-tab>
                              </b-tabs>
                            </b-card>
                          </b-tab>
                        </b-tabs>
                      </b-tab>
                      <b-tab title="Certification">
                        <b-tabs>
                          <b-tab title="Forms">
                            <b-form-group
                              label="Select Certification Forms"
                              class="mt-4"
                            >
                              <b-form-checkbox
                                inline
                                v-model="configrationSettings[configrationSettingsIndex].certificationForms.forms"
                                v-for="(forms, index) in certificationFormsOptions"
                                :key="index"
                                :value="forms"
                              >{{ forms.text }}</b-form-checkbox>
                            </b-form-group>
                          </b-tab>
                          <b-tab title="Email">
                            <b-card>
                              <b-tabs
                                small
                                nav-class="employee-languages-tabs-layout"
                              >
                                <b-tab
                                  v-for="(emailLanguage, lanuageIndex) in selectedLanguage"
                                  :key="lanuageIndex"
                                  :title="emailLanguage.text"
                                >
                                  <b-tabs
                                    justified
                                    vertical
                                    pills
                                    small
                                    fill
                                  >
                                    <b-tab title="Tasks Email">
                                      <label class="mt-3 mb-0">Tasks Email</label>
                                      <div class="my-2">
                                        <b-row>
                                          <b-col cols="6">
                                            <b-card>
                                              <b-card-body
                                                class="p-0"
                                                style="height: 70px;overflow-y: auto;"
                                              >
                                                <span
                                                  v-for="(tags, tagsIndex) in configrationSettings[configrationSettingsIndex].configration.emailTags"
                                                  :key="tagsIndex"
                                                  class="mr-2"
                                                >
                                                  <b-badge variant="success">
                                                    <p @click="setTagValue('[['+tags.text+']]', configrationSettingsIndex, emailLanguage.value, 'certificationForms', 'tasksEmail')">{{ tags.text }}</p>
                                                  </b-badge>
                                                </span>
                                              </b-card-body>
                                            </b-card>
                                          </b-col>
                                          <b-col cols="6">
                                            <b-card>
                                              <b-card-body
                                                class="p-0"
                                                style="height: 70px;overflow-y: auto;"
                                              >
                                                <span
                                                  v-for="(platform, platformIndex) in configrationSettings[configrationSettingsIndex].configration.platformSettings"
                                                  :key="platformIndex"
                                                  class="mr-2"
                                                >
                                                  <b-badge
                                                    variant="success"
                                                    style="cursor: pointer;"
                                                  >
                                                    <p @click="setTagValue('{{'+platform.platform_variable_key+'}}', configrationSettingsIndex, emailLanguage.value, 'certificationForms', 'tasksEmail')">{{ platform.platform_variable_name }}</p>
                                                  </b-badge>
                                                </span>
                                              </b-card-body>
                                            </b-card>
                                          </b-col>
                                        </b-row>
                                      </div>
                                      <b-form-group
                                        class="my-3"
                                        label="Email Subject"
                                      >
                                        <b-form-input
                                          v-model="configrationSettings[configrationSettingsIndex].certificationForms.emails[emailLanguage.value].tasksEmail.subject"
                                          size="sm"
                                        ></b-form-input>
                                      </b-form-group>
                                      <b-spinner
                                        v-if="certificationFormsTasksEmail"
                                        label="Spinning"
                                      ></b-spinner>
                                      <b-form-group
                                        v-else
                                        label="Email Body"
                                      >
                                        <wysiwyg v-model="configrationSettings[configrationSettingsIndex].certificationForms.emails[emailLanguage.value].tasksEmail.message" />
                                      </b-form-group>
                                    </b-tab>
                                    <b-tab title="Tasks Reminder Email">
                                      <label class="mt-3 mb-0">Tasks Reminder Email</label>
                                      <div class="my-2">
                                        <b-row>
                                          <b-col cols="6">
                                            <b-card>
                                              <b-card-body
                                                class="p-0"
                                                style="height: 70px;overflow-y: auto;"
                                              >
                                                <span
                                                  v-for="(tags, tagsIndex) in configrationSettings[configrationSettingsIndex].configration.emailTags"
                                                  :key="tagsIndex"
                                                  class="mr-2"
                                                >
                                                  <b-badge variant="success">
                                                    <p @click="setTagValue('[['+tags.text+']]', configrationSettingsIndex, emailLanguage.value, 'certificationForms', 'taskReminderEmail')">{{ tags.text }}</p>
                                                  </b-badge>
                                                </span>
                                              </b-card-body>
                                            </b-card>
                                          </b-col>
                                          <b-col cols="6">
                                            <b-card>
                                              <b-card-body
                                                class="p-0"
                                                style="height: 70px;overflow-y: auto;"
                                              >
                                                <span
                                                  v-for="(platform, platformIndex) in configrationSettings[configrationSettingsIndex].configration.platformSettings"
                                                  :key="platformIndex"
                                                  class="mr-2"
                                                >
                                                  <b-badge
                                                    variant="success"
                                                    style="cursor: pointer;"
                                                  >
                                                    <p @click="setTagValue('{{'+platform.platform_variable_key+'}}', configrationSettingsIndex, emailLanguage.value, 'certificationForms', 'taskReminderEmail')">{{ platform.platform_variable_name }}</p>
                                                  </b-badge>
                                                </span>
                                              </b-card-body>
                                            </b-card>
                                          </b-col>
                                        </b-row>
                                      </div>
                                      <b-form-group
                                        class="my-3"
                                        label="Email Subject"
                                      >
                                        <b-form-input
                                          v-model="configrationSettings[configrationSettingsIndex].certificationForms.emails[emailLanguage.value].taskReminderEmail.subject"
                                          size="sm"
                                        ></b-form-input>
                                      </b-form-group>
                                      <b-spinner
                                        v-if="certificationFormsTasksReminderEmail"
                                        label="Spinning"
                                      ></b-spinner>
                                      <b-form-group
                                        v-else
                                        label="Email Body"
                                      >
                                        <wysiwyg v-model="configrationSettings[configrationSettingsIndex].certificationForms.emails[emailLanguage.value].taskReminderEmail.message" />
                                      </b-form-group>
                                    </b-tab>
                                    <b-tab title="Tasks Completion Email">
                                      <label class="mt-3 mb-0">Tasks Completion Email</label>
                                      <div class="my-2">
                                        <b-row>
                                          <b-col cols="6">
                                            <b-card>
                                              <b-card-body
                                                class="p-0"
                                                style="height: 70px;overflow-y: auto;"
                                              >
                                                <span
                                                  v-for="(tags, tagsIndex) in configrationSettings[configrationSettingsIndex].configration.emailTags"
                                                  :key="tagsIndex"
                                                  class="mr-2"
                                                >
                                                  <b-badge variant="success">
                                                    <p @click="setTagValue('[['+tags.text+']]', configrationSettingsIndex, emailLanguage.value, 'certificationForms', 'taskCompletionEmail')">{{ tags.text }}</p>
                                                  </b-badge>
                                                </span>
                                              </b-card-body>
                                            </b-card>
                                          </b-col>
                                          <b-col cols="6">
                                            <b-card>
                                              <b-card-body
                                                class="p-0"
                                                style="height: 70px;overflow-y: auto;"
                                              >
                                                <span
                                                  v-for="(platform, platformIndex) in configrationSettings[configrationSettingsIndex].configration.platformSettings"
                                                  :key="platformIndex"
                                                  class="mr-2"
                                                >
                                                  <b-badge
                                                    variant="success"
                                                    style="cursor: pointer;"
                                                  >
                                                    <p @click="setTagValue('{{'+platform.platform_variable_key+'}}', configrationSettingsIndex, emailLanguage.value, 'certificationForms', 'taskCompletionEmail')">{{ platform.platform_variable_name }}</p>
                                                  </b-badge>
                                                </span>
                                              </b-card-body>
                                            </b-card>
                                          </b-col>
                                        </b-row>
                                      </div>
                                      <b-form-group
                                        class="my-3"
                                        label="Email Subject"
                                      >
                                        <b-form-input
                                          v-model="configrationSettings[configrationSettingsIndex].certificationForms.emails[emailLanguage.value].taskCompletionEmail.subject"
                                          size="sm"
                                        ></b-form-input>
                                      </b-form-group>
                                      <b-spinner
                                        v-if="certificationFormsTasksCompletionEmail"
                                        label="Spinning"
                                      ></b-spinner>
                                      <b-form-group
                                        v-else
                                        label="Email Body"
                                      >
                                        <wysiwyg v-model="configrationSettings[configrationSettingsIndex].certificationForms.emails[emailLanguage.value].taskCompletionEmail.message" />
                                      </b-form-group>
                                    </b-tab>
                                    <b-tab title="Renew Tasks Email">
                                      <label class="mt-3 mb-0">Renew Tasks Email</label>
                                      <div class="my-2">
                                        <b-row>
                                          <b-col cols="6">
                                            <b-card>
                                              <b-card-body
                                                class="p-0"
                                                style="height: 70px;overflow-y: auto;"
                                              >
                                                <span
                                                  v-for="(tags, tagsIndex) in configrationSettings[configrationSettingsIndex].configration.emailTags"
                                                  :key="tagsIndex"
                                                  class="mr-2"
                                                >
                                                  <b-badge variant="success">
                                                    <p @click="setTagValue('[['+tags.text+']]', configrationSettingsIndex, emailLanguage.value, 'certificationForms', 'renewTasksEmail')">{{ tags.text }}</p>
                                                  </b-badge>
                                                </span>
                                              </b-card-body>
                                            </b-card>
                                          </b-col>
                                          <b-col cols="6">
                                            <b-card>
                                              <b-card-body
                                                class="p-0"
                                                style="height: 70px;overflow-y: auto;"
                                              >
                                                <span
                                                  v-for="(platform, platformIndex) in configrationSettings[configrationSettingsIndex].configration.platformSettings"
                                                  :key="platformIndex"
                                                  class="mr-2"
                                                >
                                                  <b-badge
                                                    variant="success"
                                                    style="cursor: pointer;"
                                                  >
                                                    <p @click="setTagValue('{{'+platform.platform_variable_key+'}}', configrationSettingsIndex, emailLanguage.value, 'certificationForms', 'renewTasksEmail')">{{ platform.platform_variable_name }}</p>
                                                  </b-badge>
                                                </span>
                                              </b-card-body>
                                            </b-card>
                                          </b-col>
                                        </b-row>
                                      </div>
                                      <b-form-group
                                        class="my-3"
                                        label="Email Subject"
                                      >
                                        <b-form-input
                                          v-model="configrationSettings[configrationSettingsIndex].certificationForms.emails[emailLanguage.value].renewTasksEmail.subject"
                                          size="sm"
                                        ></b-form-input>
                                      </b-form-group>
                                      <b-spinner
                                        v-if="certificationFormsRenewTasksEmail"
                                        label="Spinning"
                                      ></b-spinner>
                                      <b-form-group
                                        v-else
                                        label="Email Body"
                                      >
                                        <wysiwyg v-model="configrationSettings[configrationSettingsIndex].trainingForms.emails[emailLanguage.value].renewTasksEmail.message" />
                                      </b-form-group>
                                    </b-tab>
                                  </b-tabs>
                                </b-tab>
                              </b-tabs>
                            </b-card>
                          </b-tab>
                        </b-tabs>
                      </b-tab>
                      <b-tab title="Email">
                        <b-card>
                          <b-tabs
                            small
                            nav-class="employee-languages-tabs-layout"
                          >
                            <b-tab
                              v-for="(emailLanguage, lanuageIndex) in selectedLanguage"
                              :key="lanuageIndex"
                              :title="emailLanguage.text"
                            >
                              <b-tabs
                                justified
                                vertical
                                pills
                                small
                                fill
                              >
                                <b-tab title="Welcome Email">
                                  <label class="mt-3 mb-0">Welcome Email</label>
                                  <div class="my-2">
                                    <b-row>
                                      <b-col cols="6">
                                        <b-card>
                                          <b-card-body
                                            class="p-0"
                                            style="height: 70px;overflow-y: auto;"
                                          >
                                            <span
                                              v-for="(tags, tagsIndex) in configrationSettings[configrationSettingsIndex].configration.emailTags"
                                              :key="tagsIndex"
                                              class="mr-2"
                                            >
                                              <b-badge variant="success">
                                                <p @click="setTagValue('[['+tags.text+']]', configrationSettingsIndex, emailLanguage.value, 'emails', 'welcomeEmail')">{{ tags.text }}</p>
                                              </b-badge>
                                            </span>
                                          </b-card-body>
                                        </b-card>
                                      </b-col>
                                      <b-col cols="6">
                                        <b-card>
                                          <b-card-body
                                            class="p-0"
                                            style="height: 70px;overflow-y: auto;"
                                          >
                                            <span
                                              v-for="(platform, platformIndex) in configrationSettings[configrationSettingsIndex].configration.platformSettings"
                                              :key="platformIndex"
                                              class="mr-2"
                                            >
                                              <b-badge
                                                variant="success"
                                                style="cursor: pointer;"
                                              >
                                                <p @click="setTagValue('{{'+platform.platform_variable_key+'}}', configrationSettingsIndex, emailLanguage.value, 'emails', 'welcomeEmail')">{{ platform.platform_variable_name }}</p>
                                              </b-badge>
                                            </span>
                                          </b-card-body>
                                        </b-card>
                                      </b-col>
                                    </b-row>
                                  </div>
                                  <b-form-group
                                    class="my-3"
                                    label="Email Subject"
                                  >
                                    <b-form-input
                                      v-model="configrationSettings[configrationSettingsIndex].emails[emailLanguage.value].welcomeEmail.subject"
                                      size="sm"
                                    ></b-form-input>
                                  </b-form-group>
                                  <b-spinner
                                    v-if="emailsWelcomeEmail"
                                    label="Spinning"
                                  ></b-spinner>
                                  <b-form-group
                                    v-else
                                    label="Email Body"
                                  >
                                    <wysiwyg v-model="configrationSettings[configrationSettingsIndex].emails[emailLanguage.value].welcomeEmail.message" />
                                  </b-form-group>
                                </b-tab>
                                <!-- <b-tab title="Tasks Email">
                                  <label class="mt-3 mb-0">Tasks Email</label>
                                  <div class="my-2">
                                    <b-row>
                                      <b-col cols="6">
                                        <b-card>
                                          <b-card-body class="p-0" style="height: 70px;overflow-y: auto;">
                                            <span
                                              v-for="(tags, tagsIndex) in configrationSettings[configrationSettingsIndex].configration.emailTags"
                                              :key="tagsIndex"
                                              class="mr-2"
                                            >
                                              <b-badge variant="success">
                                                <p @click="setTagValue('[['+tags.text+']]', configrationSettingsIndex, emailLanguage.value, 'emails', 'tasksEmail')">{{ tags.text }}</p>
                                              </b-badge>
                                            </span>
                                          </b-card-body>
                                        </b-card>
                                      </b-col>
                                      <b-col cols="6">
                                        <b-card>
                                          <b-card-body class="p-0" style="height: 70px;overflow-y: auto;">
                                            <span
                                              v-for="(platform, platformIndex) in configrationSettings[configrationSettingsIndex].configration.platformSettings"
                                              :key="platformIndex"
                                              class="mr-2"
                                            >
                                              <b-badge
                                                variant="success"
                                                style="cursor: pointer;"
                                              >
                                                <p @click="setTagValue('{{'+platform.platform_variable_key+'}}', configrationSettingsIndex, emailLanguage.value, 'emails', 'tasksEmail')">{{ platform.platform_variable_name }}</p>
                                              </b-badge>
                                            </span>
                                          </b-card-body>
                                        </b-card>
                                      </b-col>
                                    </b-row>
                                  </div>
                                  <b-form-group
                                    class="my-3"
                                    label="Email Subject"
                                  >
                                    <b-form-input
                                      v-model="configrationSettings[configrationSettingsIndex].emails[emailLanguage.value].tasksEmail.subject"
                                      size="sm"
                                    ></b-form-input>
                                  </b-form-group>
                                  <b-spinner
                                    v-if="emailsTasksEmail"
                                    label="Spinning"
                                  ></b-spinner>
                                  <b-form-group
                                    v-else
                                    label="Email Body"
                                  >
                                    <wysiwyg v-model="configrationSettings[configrationSettingsIndex].emails[emailLanguage.value].tasksEmail.message" />
                                  </b-form-group>
                                </b-tab>
                                <b-tab title="Tasks Completion Email">
                                  <label class="mt-3 mb-0">Tasks Completion Email</label>
                                  <div class="my-2">
                                    <b-row>
                                      <b-col cols="6">
                                        <b-card>
                                          <b-card-body class="p-0" style="height: 70px;overflow-y: auto;">
                                            <span
                                              v-for="(tags, tagsIndex) in configrationSettings[configrationSettingsIndex].configration.emailTags"
                                              :key="tagsIndex"
                                              class="mr-2"
                                            >
                                              <b-badge variant="success">
                                                <p @click="setTagValue('[['+tags.text+']]', configrationSettingsIndex, emailLanguage.value, 'emails', 'taskCompletionEmail')">{{ tags.text }}</p>
                                              </b-badge>
                                            </span>
                                          </b-card-body>
                                        </b-card>
                                      </b-col>
                                      <b-col cols="6">
                                        <b-card>
                                          <b-card-body class="p-0" style="height: 70px;overflow-y: auto;">
                                            <span
                                              v-for="(platform, platformIndex) in configrationSettings[configrationSettingsIndex].configration.platformSettings"
                                              :key="platformIndex"
                                              class="mr-2"
                                            >
                                              <b-badge
                                                variant="success"
                                                style="cursor: pointer;"
                                              >
                                                <p @click="setTagValue('{{'+platform.platform_variable_key+'}}', configrationSettingsIndex, emailLanguage.value, 'emails', 'taskCompletionEmail')">{{ platform.platform_variable_name }}</p>
                                              </b-badge>
                                            </span>
                                          </b-card-body>
                                        </b-card>
                                      </b-col>
                                    </b-row>
                                  </div>
                                  <b-form-group
                                    class="my-3"
                                    label="Email Subject"
                                  >
                                    <b-form-input
                                      v-model="configrationSettings[configrationSettingsIndex].emails[emailLanguage.value].taskCompletionEmail.subject"
                                      size="sm"
                                    ></b-form-input>
                                  </b-form-group>
                                  <b-spinner
                                    v-if="emailsTaskCompletionEmail"
                                    label="Spinning"
                                  ></b-spinner>
                                  <b-form-group
                                    v-else
                                    label="Email Body"
                                  >
                                    <wysiwyg v-model="configrationSettings[configrationSettingsIndex].emails[emailLanguage.value].taskCompletionEmail.message" />
                                  </b-form-group>
                                </b-tab>
                                <b-tab title="Tasks Reminder Email">
                                  <label class="mt-3 mb-0">Tasks Reminder Email</label>
                                  <div class="my-2">
                                    <b-row>
                                      <b-col cols="6">
                                        <b-card>
                                          <b-card-body class="p-0" style="height: 70px;overflow-y: auto;">
                                            <span
                                              v-for="(tags, tagsIndex) in configrationSettings[configrationSettingsIndex].configration.emailTags"
                                              :key="tagsIndex"
                                              class="mr-2"
                                            >
                                              <b-badge variant="success">
                                                <p @click="setTagValue('[['+tags.text+']]', configrationSettingsIndex, emailLanguage.value, 'emails', 'taskReminderEmail')">{{ tags.text }}</p>
                                              </b-badge>
                                            </span>
                                          </b-card-body>
                                        </b-card>
                                      </b-col>
                                      <b-col cols="6">
                                        <b-card>
                                          <b-card-body class="p-0" style="height: 70px;overflow-y: auto;">
                                            <span
                                              v-for="(platform, platformIndex) in configrationSettings[configrationSettingsIndex].configration.platformSettings"
                                              :key="platformIndex"
                                              class="mr-2"
                                            >
                                              <b-badge
                                                variant="success"
                                                style="cursor: pointer;"
                                              >
                                                <p @click="setTagValue('{{'+platform.platform_variable_key+'}}', configrationSettingsIndex, emailLanguage.value, 'emails', 'taskReminderEmail')">{{ platform.platform_variable_name }}</p>
                                              </b-badge>
                                            </span>
                                          </b-card-body>
                                        </b-card>
                                      </b-col>
                                    </b-row>
                                  </div>
                                  <b-form-group
                                    class="my-3"
                                    label="Email Subject"
                                  >
                                    <b-form-input
                                      v-model="configrationSettings[configrationSettingsIndex].emails[emailLanguage.value].taskReminderEmail.subject"
                                      size="sm"
                                    ></b-form-input>
                                  </b-form-group>
                                  <b-spinner
                                    v-if="emailsTaskReminderEmail"
                                    label="Spinning"
                                  ></b-spinner>
                                  <b-form-group
                                    v-else
                                    label="Email Body"
                                  >
                                    <wysiwyg v-model="configrationSettings[configrationSettingsIndex].emails[emailLanguage.value].taskReminderEmail.message" />
                                  </b-form-group>
                                </b-tab> -->
                              </b-tabs>
                            </b-tab>
                          </b-tabs>
                        </b-card>
                      </b-tab>
                    </b-tabs>
                  </b-card>
                </b-tab>
              </b-tabs>
            </b-tab>
          </b-tabs>
        </div>
        <div v-else-if="submiting && !responseSuccess">
          <p>
            {{
              isEditWorkFlow
                ? "Your Workflow is being Updating......"
                : isDuplicateWorkFlow
                ? "Your Workflow is being duplicating......"
                : "Your Workflow is being Creating......"
            }}
          </p>
          <b-spinner
            type="grow"
            label="Loading..."
          ></b-spinner>
        </div>
        <div v-else>
          <p class="my-2 text-center">
            {{
              isEditWorkFlow
                ? "Your Workflow has been updated successfully."
                : isDuplicateWorkFlow
                ? "Your Workflow has been Duplicated successfully."
                : "Your Workflow has been added successfully."
            }}
            <br />
          </p>
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button
          v-if="!submiting"
          @click="closeModal"
          variant="outline-danger"
        >Close</b-button>
        <b-button
          v-if="!submiting && !responseSuccess"
          @click="checkValidation"
          variant="outline-success"
        >{{
            isEditWorkFlow
              ? "Update"
              : isDuplicateWorkFlow
              ? "Duplicate"
              : "Save "
          }}</b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import { HTTP } from "../../../../utils/HTTP";
import { EventBus } from "@/event-bus.js";
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import "moment/locale/es";
// import CountryCodes from "../../utils/countryCodes.json";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
export default {
  name: "AddNewEmployeeModal",
  mixins: [validationMixin],
  components: {
    Datepicker,
  },
  data () {
    return {
      isEditWorkFlow: false,
      showAddModal: false,
      form: {
        title: null,
        version: null,
      },
      tasksEmailEmailTags: [],
      emailTagsOptions: [],
      platformSettingOptions: [],
      languagesOptions: [],
      selectedLanguage: [{ text: "English", value: "1" }],
      policyFormsOptions: [],
      trainingFormsOptions: [],
      certificationFormsOptions: [],
      totalRows: 0,
      filter: null,
      perPage: 10,
      currentPage: 1,
      sortBy: "id",
      sortDesc: true,
      pageOptions: [5, 10, 25, 50, 75, 100],
      staticFields: [
        { key: "id", label: "id", sortable: true },
        { key: "type", label: "Type", sortable: true },
        { key: "title", sortable: true },
        { key: "company_name", label: "Company Name", sortable: true },
        { key: "name", label: "Creator Name", sortable: true },
        { key: "created_updated", sortable: true },
      ],
      items: [
        {
          id: "1",
          type: "External Questionaire",
          title: "ST Engineering Due Diligence Questionnaire",
          company_name: "Shockwave Medical, Inc.",
          name: "Karan Jain",
          created_updated: "6 months ago",
        },
        {
          id: "2",
          type: "Training",
          title: "Carasol Test",
          company_name: "DS Dealers Test",
          name: "Karan Jain",
          created_updated: "a months ago",
        },
        {
          id: "3",
          type: "Training",
          title: "frweraeds",
          company_name: "STE Company QA",
          name: "Karan Jain",
          created_updated: "a months ago",
        },
      ],
      configrationSettings: [
        {
          title: null,
          startDate: null,
          endDateValue: null,
          configration: {
            emailTags: [],
            platformSettings: []
          },
          policyForms: {
            forms: [],
            emails: null,
          },
          trainingForms: {
            forms: [],
            emails: null,
          },
          certificationForms: {
            forms: [],
            emails: null,
          },
          emails: null,
        },
      ],
      submiting: false,
      isLoading: false,
      responseSuccess: false,
      workflowSettingId: null,
      invalidTitleValue: null,
      invalidStartDateValue: null,
      invalidEndDateValue: null,
      configurationTitleIndex: null,
      configurationStartDateIndex: null,
      configurationEndDateIndex: null,
      isDuplicateWorkFlow: false,
      selectedLanguageLenght: null,
      formsEmails: {},
      setupEmails: {},
      policyFormsTasksEmail: false,
      policyFormsTasksReminderEmail: false,
      policyFormsTasksCompletionEmail: false,
      policyFormsRenewTasksEmail: false,
      trainingFormsTasksEmail: false,
      trainingFormsTasksReminderEmail: false,
      trainingFormsRenewTasksEmail: false,
      trainingFormsTasksCompletionEmail: false,
      certificationFormsTasksEmail: false,
      certificationFormsTasksReminderEmail: false,
      certificationFormsTasksCompletionEmail: false,
      certificationFormsRenewTasksEmail: false,
      emailsWelcomeEmail: false,
      emailsTasksEmail: false,
      emailsTaskCompletionEmail: false,
      emailsTaskReminderEmail: false,
      configrationSettingsIndex: 0
    };
  },
  validations: {
    form: {
      title: { required },
      version: { required },
    },
  },
  created () {
    EventBus.$on( "onShowAddNewEmployeeModal", () => {
      this.showAddNewEmployeeModal();
    } );
    EventBus.$on( "onShowEditWorkflowSettingModal", ( value ) => {
      this.showEditWorkflowModal( value );
    } );
    EventBus.$on( "onShowDuplicateWorkflowSettingModal", ( value ) => {
      this.showDuplicateWorkflowModal( value );
    } );
  },
  computed: {
    rows () {
      return this.totalRows;
    },
  },
  mounted () {
    this.getEmployeeLanguages();
    this.getFormsOptions();
    this.getEmailTagsList();
    this.getPlatformSettingList();
  },
  methods: {
    setTagValue ( selectedValue, configurTabIndex, emailLanguageValue, formTab, emailTab ) {
      let tasksEmail = null;
      let taskReminderEmail = null;
      let taskCompletionEmail = null;
      let renewTasksEmail = null;
      let welcomeEmail = null;
      if ( formTab == 'policyForms' ) {
        if ( emailTab == 'tasksEmail' ) {
          if ( this.configrationSettings[this.configrationSettingsIndex].policyForms.emails[emailLanguageValue].tasksEmail.message == null ) {
            this.configrationSettings[this.configrationSettingsIndex].policyForms.emails[emailLanguageValue].tasksEmail.message = selectedValue
          } else {
            tasksEmail = this.configrationSettings[this.configrationSettingsIndex].policyForms.emails[emailLanguageValue].tasksEmail.message + '' + selectedValue;
            this.configrationSettings[this.configrationSettingsIndex].policyForms.emails[emailLanguageValue].tasksEmail.message = tasksEmail;
          }
          this.policyFormsTasksEmail = true;
          setTimeout( () => {
            this.policyFormsTasksEmail = false;
          }, 100 );
        }
        if ( emailTab == 'taskReminderEmail' ) {
          if ( this.configrationSettings[this.configrationSettingsIndex].policyForms.emails[emailLanguageValue].taskReminderEmail.message == null ) {
            this.configrationSettings[this.configrationSettingsIndex].policyForms.emails[emailLanguageValue].taskReminderEmail.message = selectedValue
          } else {
            taskReminderEmail = this.configrationSettings[this.configrationSettingsIndex].policyForms.emails[emailLanguageValue].taskReminderEmail.message + '' + selectedValue;
            this.configrationSettings[this.configrationSettingsIndex].policyForms.emails[emailLanguageValue].taskReminderEmail.message = taskReminderEmail;
          }
          this.policyFormsTasksReminderEmail = true;
          setTimeout( () => {
            this.policyFormsTasksReminderEmail = false;
          }, 100 );
        }
        if ( emailTab == 'taskCompletionEmail' ) {
          if ( this.configrationSettings[this.configrationSettingsIndex].policyForms.emails[emailLanguageValue].taskCompletionEmail.message == null ) {
            this.configrationSettings[this.configrationSettingsIndex].policyForms.emails[emailLanguageValue].taskCompletionEmail.message = selectedValue
          } else {
            taskCompletionEmail = this.configrationSettings[this.configrationSettingsIndex].policyForms.emails[emailLanguageValue].taskCompletionEmail.message + '' + selectedValue;
            this.configrationSettings[this.configrationSettingsIndex].policyForms.emails[emailLanguageValue].taskCompletionEmail.message = taskCompletionEmail;
          }
          this.policyFormsTasksCompletionEmail = true;
          setTimeout( () => {
            this.policyFormsTasksCompletionEmail = false;
          }, 100 );
        }
        if ( emailTab == 'renewTasksEmail' ) {
          if ( this.configrationSettings[this.configrationSettingsIndex].policyForms.emails[emailLanguageValue].renewTasksEmail.message == null ) {
            this.configrationSettings[this.configrationSettingsIndex].policyForms.emails[emailLanguageValue].renewTasksEmail.message = selectedValue
          } else {
            renewTasksEmail = this.configrationSettings[this.configrationSettingsIndex].policyForms.emails[emailLanguageValue].renewTasksEmail.message + '' + selectedValue;
            this.configrationSettings[this.configrationSettingsIndex].policyForms.emails[emailLanguageValue].renewTasksEmail.message = renewTasksEmail;
          }
          this.policyFormsRenewTasksEmail = true;
          setTimeout( () => {
            this.policyFormsRenewTasksEmail = false;
          }, 100 );
        }
      }
      if ( formTab == 'trainingForms' ) {
        if ( emailTab == 'tasksEmail' ) {
          if ( this.configrationSettings[this.configrationSettingsIndex].trainingForms.emails[emailLanguageValue].tasksEmail.message == null ) {
            this.configrationSettings[this.configrationSettingsIndex].trainingForms.emails[emailLanguageValue].tasksEmail.message = selectedValue
          } else {
            tasksEmail = this.configrationSettings[this.configrationSettingsIndex].trainingForms.emails[emailLanguageValue].tasksEmail.message + '' + selectedValue;
            this.configrationSettings[this.configrationSettingsIndex].trainingForms.emails[emailLanguageValue].tasksEmail.message = tasksEmail;
          }
          this.trainingFormsTasksEmail = true;
          setTimeout( () => {
            this.trainingFormsTasksEmail = false;
          }, 100 );
        }
        if ( emailTab == 'taskReminderEmail' ) {
          if ( this.configrationSettings[this.configrationSettingsIndex].trainingForms.emails[emailLanguageValue].taskReminderEmail.message == null ) {
            this.configrationSettings[this.configrationSettingsIndex].trainingForms.emails[emailLanguageValue].taskReminderEmail.message = selectedValue
          } else {
            taskReminderEmail = this.configrationSettings[this.configrationSettingsIndex].trainingForms.emails[emailLanguageValue].taskReminderEmail.message + '' + selectedValue;
            this.configrationSettings[this.configrationSettingsIndex].trainingForms.emails[emailLanguageValue].taskReminderEmail.message = taskReminderEmail;
          }
          this.trainingFormsTasksReminderEmail = true;
          setTimeout( () => {
            this.trainingFormsTasksReminderEmail = false;
          }, 100 );
        }
        if ( emailTab == 'taskCompletionEmail' ) {
          if ( this.configrationSettings[this.configrationSettingsIndex].trainingForms.emails[emailLanguageValue].taskCompletionEmail.message == null ) {
            this.configrationSettings[this.configrationSettingsIndex].trainingForms.emails[emailLanguageValue].taskCompletionEmail.message = selectedValue
          } else {
            taskCompletionEmail = this.configrationSettings[this.configrationSettingsIndex].trainingForms.emails[emailLanguageValue].taskCompletionEmail.message + '' + selectedValue;
            this.configrationSettings[this.configrationSettingsIndex].trainingForms.emails[emailLanguageValue].taskCompletionEmail.message = taskCompletionEmail;
          }
          this.trainingFormsTasksCompletionEmail = true;
          setTimeout( () => {
            this.trainingFormsTasksCompletionEmail = false;
          }, 100 );
        }
        if ( emailTab == 'renewTasksEmail' ) {
          if ( this.configrationSettings[this.configrationSettingsIndex].trainingForms.emails[emailLanguageValue].renewTasksEmail.message == null ) {
            this.configrationSettings[this.configrationSettingsIndex].trainingForms.emails[emailLanguageValue].renewTasksEmail.message = selectedValue
          } else {
            renewTasksEmail = this.configrationSettings[this.configrationSettingsIndex].trainingForms.emails[emailLanguageValue].renewTasksEmail.message + '' + selectedValue;
            this.configrationSettings[this.configrationSettingsIndex].trainingForms.emails[emailLanguageValue].renewTasksEmail.message = renewTasksEmail;
          }
          this.trainingFormsRenewTasksEmail = true;
          setTimeout( () => {
            this.trainingFormsRenewTasksEmail = false;
          }, 100 );
        }
      }
      if ( formTab == 'certificationForms' ) {
        if ( emailTab == 'tasksEmail' ) {
          if ( this.configrationSettings[this.configrationSettingsIndex].certificationForms.emails[emailLanguageValue].tasksEmail.message == null ) {
            this.configrationSettings[this.configrationSettingsIndex].certificationForms.emails[emailLanguageValue].tasksEmail.message = selectedValue
          } else {
            tasksEmail = this.configrationSettings[this.configrationSettingsIndex].certificationForms.emails[emailLanguageValue].tasksEmail.message + '' + selectedValue;
            this.configrationSettings[this.configrationSettingsIndex].certificationForms.emails[emailLanguageValue].tasksEmail.message = tasksEmail;
          }
          this.certificationFormsTasksEmail = true;
          setTimeout( () => {
            this.certificationFormsTasksEmail = false;
          }, 100 );
        }
        if ( emailTab == 'taskReminderEmail' ) {
          if ( this.configrationSettings[this.configrationSettingsIndex].certificationForms.emails[emailLanguageValue].taskReminderEmail.message == null ) {
            this.configrationSettings[this.configrationSettingsIndex].certificationForms.emails[emailLanguageValue].taskReminderEmail.message = selectedValue
          } else {
            taskReminderEmail = this.configrationSettings[this.configrationSettingsIndex].certificationForms.emails[emailLanguageValue].taskReminderEmail.message + '' + selectedValue;
            this.configrationSettings[this.configrationSettingsIndex].certificationForms.emails[emailLanguageValue].taskReminderEmail.message = taskReminderEmail;
          }
          this.certificationFormsTasksReminderEmail = true;
          setTimeout( () => {
            this.certificationFormsTasksReminderEmail = false;
          }, 100 );
        }
        if ( emailTab == 'taskCompletionEmail' ) {
          if ( this.configrationSettings[this.configrationSettingsIndex].certificationForms.emails[emailLanguageValue].taskCompletionEmail.message == null ) {
            this.configrationSettings[this.configrationSettingsIndex].certificationForms.emails[emailLanguageValue].taskCompletionEmail.message = selectedValue
          } else {
            taskCompletionEmail = this.configrationSettings[this.configrationSettingsIndex].certificationForms.emails[emailLanguageValue].taskCompletionEmail.message + '' + selectedValue;
            this.configrationSettings[this.configrationSettingsIndex].certificationForms.emails[emailLanguageValue].taskCompletionEmail.message = taskCompletionEmail;
          }
          this.certificationFormsTasksCompletionEmail = true;
          setTimeout( () => {
            this.certificationFormsTasksCompletionEmail = false;
          }, 100 );
        }
        if ( emailTab == 'renewTasksEmail' ) {
          if ( this.configrationSettings[this.configrationSettingsIndex].certificationForms.emails[emailLanguageValue].renewTasksEmail.message == null ) {
            this.configrationSettings[this.configrationSettingsIndex].certificationForms.emails[emailLanguageValue].renewTasksEmail.message = selectedValue
          } else {
            renewTasksEmail = this.configrationSettings[this.configrationSettingsIndex].certificationForms.emails[emailLanguageValue].renewTasksEmail.message + '' + selectedValue;
            this.configrationSettings[this.configrationSettingsIndex].certificationForms.emails[emailLanguageValue].renewTasksEmail.message = renewTasksEmail;
          }
          this.certificationFormsRenewTasksEmail = true;
          setTimeout( () => {
            this.certificationFormsRenewTasksEmail = false;
          }, 100 );
        }
      }
      if ( formTab == 'emails' ) {
        if ( emailTab == 'welcomeEmail' ) {
          if ( this.configrationSettings[this.configrationSettingsIndex].emails[emailLanguageValue].welcomeEmail.message == null ) {
            this.configrationSettings[this.configrationSettingsIndex].emails[emailLanguageValue].welcomeEmail.message = selectedValue
          } else {
            welcomeEmail = this.configrationSettings[this.configrationSettingsIndex].emails[emailLanguageValue].welcomeEmail.message + '' + selectedValue;
            this.configrationSettings[this.configrationSettingsIndex].emails[emailLanguageValue].welcomeEmail.message = welcomeEmail;
          }
          this.emailsWelcomeEmail = true;
          setTimeout( () => {
            this.emailsWelcomeEmail = false;
          }, 100 );
        }
        // if ( emailTab == 'tasksEmail' ) {
        //   tasksEmail = this.configrationSettings[this.configrationSettingsIndex].emails[emailLanguageValue].tasksEmail.message + '' + selectedValue;
        //   this.configrationSettings[this.configrationSettingsIndex].emails[emailLanguageValue].tasksEmail.message = tasksEmail;
        //   this.emailsTasksEmail = true;
        //   setTimeout( () => {
        //     this.emailsTasksEmail = false;
        //   }, 100 );
        // }
        // if ( emailTab == 'taskCompletionEmail' ) {
        //   taskCompletionEmail = this.configrationSettings[this.configrationSettingsIndex].emails[emailLanguageValue].taskCompletionEmail.message + '' + selectedValue;
        //   this.configrationSettings[this.configrationSettingsIndex].emails[emailLanguageValue].taskCompletionEmail.message = taskCompletionEmail;
        //   this.emailsTaskCompletionEmail = true;
        //   setTimeout( () => {
        //     this.emailsTaskCompletionEmail = false;
        //   }, 100 );
        // }
        // if ( emailTab == 'taskReminderEmail' ) {
        //   taskReminderEmail = this.configrationSettings[this.configrationSettingsIndex].emails[emailLanguageValue].taskReminderEmail.message + '' + selectedValue;
        //   this.configrationSettings[this.configrationSettingsIndex].emails[emailLanguageValue].taskReminderEmail.message = taskReminderEmail;
        //   this.emailsTaskReminderEmail = true;
        //   setTimeout( () => {
        //     this.emailsTaskReminderEmail = false;
        //   }, 100 );
        // }
      }
    },
    setEmailLanguages ( cloenFieldsIndex ) {
      this.configrationSettingsIndex = cloenFieldsIndex;
      if ( this.configrationSettings[cloenFieldsIndex].emails == null ) {
        this.selectedLanguageLenght = this.selectedLanguage.length;
        this.selectedLanguage.map( ( languages ) => {
          let language = languages.value;
          this.formsEmails[language] = {
            tasksEmail: {
              subject: null,
              message: null,
            },
            taskReminderEmail: {
              subject: null,
              message: null,
            },
            taskCompletionEmail: {
              subject: null,
              message: null,
            },
            renewTasksEmail: {
              subject: null,
              message: null,
            },
          };
          this.setupEmails[language] = {
            welcomeEmail: {
              subject: null,
              message: null,
            },
            // tasksEmail: {
            //   subject: null,
            //   message: null,
            // },
            // taskCompletionEmail: {
            //   subject: null,
            //   message: null,
            // },
            // taskReminderEmail: {
            //   subject: null,
            //   message: null,
            // },
          };
          this.configrationSettings[
            cloenFieldsIndex
          ].policyForms.emails = this.formsEmails;
          this.configrationSettings[
            cloenFieldsIndex
          ].trainingForms.emails = this.formsEmails;
          this.configrationSettings[
            cloenFieldsIndex
          ].certificationForms.emails = this.formsEmails;
          this.configrationSettings[cloenFieldsIndex].emails = this.setupEmails;
        } );
      } else if (
        this.selectedLanguageLenght != this.selectedLanguage.length &&
        this.configrationSettings[cloenFieldsIndex].emails != null
      ) {
        this.configrationSettings[cloenFieldsIndex].policyForms.emails = null;
        this.configrationSettings[cloenFieldsIndex].trainingForms.emails = null;
        this.configrationSettings[cloenFieldsIndex].certificationForms.emails = null;
        this.configrationSettings[cloenFieldsIndex].emails = null;
        this.selectedLanguage.map( ( languages ) => {
          let language = languages.value;
          this.formsEmails[language] = {
            tasksEmail: {
              subject: null,
              message: null,
            },
            taskReminderEmail: {
              subject: null,
              message: null,
            },
            taskCompletionEmail: {
              subject: null,
              message: null,
            },
            renewTasksEmail: {
              subject: null,
              message: null,
            },
          };
          this.setupEmails[language] = {
            welcomeEmail: {
              subject: null,
              message: null,
            },
            // tasksEmail: {
            //   subject: null,
            //   message: null,
            // },
            // taskCompletionEmail: {
            //   subject: null,
            //   message: null,
            // },
            // taskReminderEmail: {
            //   subject: null,
            //   message: null,
            // },
          };
          this.configrationSettings[
            cloenFieldsIndex
          ].policyForms.emails = this.formsEmails;
          this.configrationSettings[
            cloenFieldsIndex
          ].trainingForms.emails = this.formsEmails;
          this.configrationSettings[
            cloenFieldsIndex
          ].certificationForms.emails = this.formsEmails;
          this.configrationSettings[cloenFieldsIndex].emails = this.setupEmails;
        } );
      }
    },
    showDuplicateWorkflowModal ( value ) {
      this.configrationSettings = [];
      this.selectedLanguage = [];
      this.selectedLanguageLenght = null;
      this.isDuplicateWorkFlow = true;
      this.workflowSettingId = value.id;
      this.form = {
        title: value.title,
        version: value.version,
      };
      let configurationData = JSON.parse( value.configuration );
      if (
        configurationData.languages &&
        configurationData.languages.length > 0
      ) {
        this.selectedLanguageLenght = configurationData.languages.length;
        configurationData.languages.map( ( types ) => {
          this.selectedLanguage.push( types );
        } );
      }
      if ( configurationData.settings.length > 0 ) {
        this.configrationSettings = configurationData.settings;
      }
      this.showAddModal = true;
    },
    showEditWorkflowModal ( value ) {
      this.selectedLanguage = [];
      this.selectedLanguageLenght = null;
      this.configrationSettings = [];
      this.isEditWorkFlow = true;
      this.workflowSettingId = value.id;
      this.form = {
        title: value.title,
        version: value.version,
      };
      let configurationData = JSON.parse( value.configuration );
      if (
        configurationData.languages &&
        configurationData.languages.length > 0
      ) {
        this.selectedLanguageLenght = configurationData.languages.length;
        configurationData.languages.map( ( types ) => {
          this.selectedLanguage.push( types );
        } );
      }
      if ( configurationData.settings.length > 0 ) {
        this.configrationSettings = configurationData.settings;
      }
      this.showAddModal = true;
    },
    showAddNewEmployeeModal () {
      this.showAddModal = true;
    },
    reloadTable () {
      this.$root.$emit( "bv::refresh::table", "employee-table" );
    },
    formatDate ( value ) {
      if ( value ) {
        moment.locale( "en" );
        return moment( String( value ) ).format( "DD/MM" );
      }
    },
    setTitleValue ( value ) {
      if ( value ) {
        return "";
      } else if ( value == null ) {
        this.selectedLanguage = [{ text: "English", value: "1" }];
        this.configrationSettings = [
          {
            title: null,
            startDate: null,
            endDateValue: null,
            configration: {
              emailTags: this.emailTagsOptions,
              platformSettings: this.platformSettingOptions
            },
            policyForms: {
              forms: [],
              emails: null,
            },
            trainingForms: {
              forms: [],
              emails: null,
            },
            certificationForms: {
              forms: [],
              emails: null,
            },
            emails: null,
          },
        ];
      }
    },
    closeModal () {
      this.showAddModal = false;
      this.form = {
        title: null,
        version: null,
      };
      this.isEditWorkFlow = false;
      this.isDuplicateWorkFlow = false;
      this.workflowSettingId = null;
      this.selectedLanguage = [{ text: "English", value: "1" }];
      this.configrationSettings = [
        {
          title: null,
          startDate: null,
          endDateValue: null,
          configration: {
            emailTags: this.emailTagsOptions,
            platformSettings: this.platformSettingOptions,
          },
          policyForms: {
            forms: [],
            emails: null,
          },
          trainingForms: {
            forms: [],
            emails: null,
          },
          certificationForms: {
            forms: [],
            emails: null,
          },
          emails: null,
        },
      ];
      this.$v.$reset();
      this.submiting = false;
      this.isLoading = false;
      this.responseSuccess = false;
    },
    async getEmailTagsList () {
      this.emailTagsOptions = [];
      this.isLoading = true;
      try {
        let result = await HTTP( "get", "api/v1/tag/list", null );
        this.configrationSettings[0].configration.emailTags = result.data.emailTags;
        this.emailTagsOptions = result.data.emailTags;
        this.isLoading = false;
      } catch ( error ) {
        this.isLoading = false;
      }
    },
    async getPlatformSettingList () {
      this.platformSettingOptions = [];
      this.isLoading = true;
      try {
        let result = await HTTP( "get", "api/v1/platform/list", null );
        if ( result.data[0].platform_variables ) {
          let settings = JSON.parse( result.data[0].platform_variables );
          this.configrationSettings[0].configration.platformSettings = settings;
          this.platformSettingOptions = settings;
        }
        this.isLoading = false;
      } catch ( error ) {
        this.isLoading = false;
      }
    },
    async getEmployeeLanguages () {
      this.languagesOptions = [];
      this.isLoading = true;
      try {
        let result = await HTTP( "get", "api/v1/constants/languages-list", null );
        this.languagesOptions = result.data.employeeLanuages;
        this.isLoading = false;
      } catch ( error ) {
        this.isLoading = false;
      }
    },
    async getFormsOptions () {
      this.policyFormsOptions = [];
      this.trainingFormsOptions = [];
      this.certificationFormsOptions = [];
      this.isLoading = true;
      let token = "Bearer " + localStorage.getItem( "accessToken" );
      try {
        let result = await HTTP(
          "get",
          "api/v1/onboarding/forms/all-onboarding-forms-list",
          null,
          {
            Authorization: token,
          }
        );
        if ( result.status == 200 && result.data.onboardingForms ) {
          result.data.onboardingForms.map( ( forms ) => {
            if ( forms.onboarding_form_type_id == 2 ) {
              let relatedFormIds =
                forms.related_form_ids == null
                  ? []
                  : JSON.parse( forms.related_form_ids );
              this.policyFormsOptions.push( {
                text: forms.text,
                value: forms.value,
                reletedFormIds: relatedFormIds,
              } );
            } else if ( forms.onboarding_form_type_id == 3 ) {
              let relatedFormIds =
                forms.related_form_ids == null
                  ? []
                  : JSON.parse( forms.related_form_ids );
              this.trainingFormsOptions.push( {
                text: forms.text,
                value: forms.value,
                reletedFormIds: relatedFormIds,
              } );
            } else if ( forms.onboarding_form_type_id == 4 ) {
              let relatedFormIds =
                forms.related_form_ids == null
                  ? []
                  : JSON.parse( forms.related_form_ids );
              this.certificationFormsOptions.push( {
                text: forms.text,
                value: forms.value,
                reletedFormIds: relatedFormIds,
              } );
            }
          } );
        }
        this.isLoading = false;
      } catch ( error ) {
        this.isLoading = false;
      }
    },
    setTitleIndex ( value, cloenFieldsIndex ) {
      if ( value ) {
        this.configurationTitleIndex = cloenFieldsIndex;
        this.invalidTitleValue = null;
      } else {
        this.configurationTitleIndex = null;
      }
    },
    setStartDateIndex ( value, cloenFieldsIndex ) {
      if ( value ) {
        this.configurationStartDateIndex = cloenFieldsIndex;
        this.invalidStartDateValue = null;
      } else {
        this.configurationStartDateIndex = null;
      }
    },
    setEndDateIndex ( value, cloenFieldsIndex ) {
      if ( value ) {
        this.configurationEndDateIndex = cloenFieldsIndex;
        this.invalidEndDateValue = null;
      } else {
        this.configurationEndDateIndex = null;
      }
    },
    setSettingsLanuages ( cloenFieldsIndex ) {
      if ( this.configrationSettings[cloenFieldsIndex].emails == null ) {
        this.setEmailLanguages( cloenFieldsIndex );
      }
    },
    addRowInTable () {
      if ( this.configurationTitleIndex == null ) {
        this.invalidTitleValue = "Please Enter Title";
        return;
      } else if ( this.configurationStartDateIndex == null ) {
        this.invalidStartDateValue = "Please Select Start Date";
        return;
      } else if ( this.configurationEndDateIndex == null ) {
        this.invalidEndDateValue = "Please Select End Date";
        return;
      } else {
        this.configrationSettings.push( {
          title: null,
          startDate: null,
          endDateValue: null,
          configration: {
            emailTags: this.emailTagsOptions,
            platformSettings: this.platformSettingOptions
          },
          policyForms: {
            forms: [],
            emails: null,
          },
          trainingForms: {
            forms: [],
            emails: null,
          },
          certificationForms: {
            forms: [],
            emails: null,
          },
          emails: null,
        } );
      }
      this.configurationTitleIndex = null;
      this.configurationStartDateIndex = null;
      this.configurationEndDateIndex = null;
      this.invalidTitleValue = null;
      this.invalidStartDateValue = null;
      this.invalidEndDateValue = null;
    },
    onDeleteAmountRow ( cloenFieldsIndex ) {
      this.configrationSettings.splice( cloenFieldsIndex, 1 );
    },
    checkValidation () {
      this.$v.form.$touch();
      if ( this.$v.form.$anyError ) {
        return;
      } else if ( this.isEditWorkFlow ) {
        this.updateEmployeeWorkFlowSetting().then( this.reloadTable );
      } else {
        this.saveEmployeeWorkFlowSetting().then( this.reloadTable );
      }
    },
    async updateEmployeeWorkFlowSetting () {
      let formData = {
        user_id: localStorage.getItem( "userId" ),
        workflow_setting_id: this.workflowSettingId,
        title: this.form.title,
        version: this.form.version,
        workflow_type_id: 7,
        configuration: {
          languages: this.selectedLanguage,
          settings: this.configrationSettings,
        },
      };
      try {
        this.submiting = true;
        this.isLoading = true;
        await HTTP( "post", "api/v1/workflow/settings/update", formData );
        this.submiting = false;
        this.isLoading = false;
        this.responseSuccess = true;
      } catch ( err ) {
        this.submiting = false;
        this.isLoading = false;
        this.responseSuccess = false;
        return [err];
      }
    },
    async saveEmployeeWorkFlowSetting () {
      let formData = {
        user_id: localStorage.getItem( "userId" ),
        title: this.form.title,
        version: this.form.version,
        workflow_type_id: 7,
        configuration: {
          languages: this.selectedLanguage,
          settings: this.configrationSettings,
        },
      };
      try {
        this.submiting = true;
        this.isLoading = true;
        await HTTP( "post", "api/v1/workflow/settings/create", formData );
        this.submiting = false;
        this.isLoading = false;
        this.responseSuccess = true;
      } catch ( err ) {
        this.submiting = false;
        this.isLoading = false;
        this.responseSuccess = false;
        return [err];
      }
    },
  },
};
</script>
<style>
.custom-date-picker {
  width: 100%;
  border: none;
}
.custom-date-picker:focus {
  border: none;
}
.date-calender {
  width: 235px !important;
  background: #dee2e6 !important;
}
.form-control-small-date-picker {
  height: calc(1.5em + 0.5rem + 2px);
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.2rem;
}
.workflow-setting-custom-date-picker {
  width: 100%;
  border: none;
}
.workflow-setting-custom-date-picker:focus {
  border: none;
}
.workflow-setting-date-calender {
  width: 235px !important;
  background: #dee2e6 !important;
}
.employee-languages-tabs-layout {
  width: 50rem;
  transform: translateX(12rem);
}
</style>
